import {connect} from 'react-redux';
import axios from 'axios';
import {Alert,  Platform} from "react-native"

import ChangPssScreen from '../ChangePassScreen';
import {typeExport} from "../../../../../redux/store/type";
import {
    serviceActionSetState,
    serviceActionSetToken,
    serviceActionSetTypeLogin,
    serviceActionSetUser
} from "../../../splash/action/ActionSplashGetAllData";
import i18n from "../../../../../I18n/i18n";
import {AsyngStorageClass} from "../../../../../tools/AsyngStorageClass";
import {Tools} from "../../../../../tools/Tools";
import base64 from "react-native-base64";
import store from "../../../../../redux/store";
import * as NavigationService from "../../../../../redux/NavigationService";
import HMAlert from "../../../../../customviews/HMAlert";
const mapStateToProps = (state) => ({
    results: state.reducerChangPssScreen.results,
    NoInternetDialog: state.reducerChangPssScreen.NoInternetDialog,
    isLoading: state.reducerChangPssScreen.isLoading,

    DataSplashScreen: state.reducerSplashGetAllData,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection) => dispatch(callWebservice(getState, url, params, type, typeConnection)),
    callServiceSetState: (data) => dispatch(serviceActionSetState(data)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection) => {
    dispatch(serviceActionPending());
    // axios(
    //     {
    //         url: baseUrl + url + params,
    //         method: typeConnection,
    //         headers: {
    //             'Content-Type': 'application/x-www-form-urlencoded'
    //         },
    //
    //     }
    // )
    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            // 'Content-Type': 'application/json',
            "Authorization": params.token == null ? `Basic ${base64.encode(Tools.persianToEnglish(global._mobile) + ':' + Tools.persianToEnglish(global.CodeMobile))}` : `Basic ${params.token}`,
            // "Authorization": `Basic ${params.token}`,
            timeout: typeExport._TIMEOUT,
        }
    };
    const formData = new FormData();
    formData.append('_operation', params.token != null ? typeExport._Contacts : typeExport._Registration);
    formData.append('mode', params.mode);
    formData.append('lang', params.lang);
    formData.append('token_fb', store.getState().reducerSplashGetAllData.token_fb);
    if (params.token == null)
        formData.append('token_code', `Basic ${base64.encode(Tools.persianToEnglish(global._mobile) + ':' + Tools.persianToEnglish(global.CodeMobile))}`);
    else
        formData.append('token', params.token);

    formData.append('password', params.password);
    formData.append('newPassword', params.newPassword);
    Tools.addAllFormData(formData,true,"City");

    //axios.post(url, formData, config)
    axios({
        method: 'post',
        url: url,
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data',
            "Authorization": `Basic ${params.token}`
        },
        timeout: typeExport._TIMEOUT,

    })
        .then(response => {
            switch (type) {

                case typeExport.TypeGetChangPssScreen:
                    if (response.data.success) {

                        dispatch(serviceActionSuccess(response.data))
                        Tools.SaveTokenUserAsyncProps(response.data.result.token, response.data.result)
                        HMAlert(i18n.t('constant.message'), response.data.result.message, [
                                // {text: 'Ask me later', onPress: () => console
                                // {text: 'Cancel', onPress: () => {}, style: 'cancel'},
                                {
                                    text: i18n.t('constant.ok'), onPress: async () => {
                                        if (getState.route.params.forgot_my_password) {
                                            await AsyngStorageClass.setAsyng(typeExport._TypeLogin, 1);
                                            dispatch(serviceActionSetTypeLogin(1));

                                            Tools.SaveTokenUserAsyncProps(response.data.result.token, response.data.result)
                                            //NavigationService.resetTo("Drawer")

                                            if (global.ErrorLogin) {
                                                global.ErrorLogin = false
                                                NavigationService.resetTo('SplashScreen')
                                            }
                                            else {
                                                NavigationService.PopToPop();
                                                try {

                                                    NavigationService.navigateParams(store.getState().reducerSplashGetAllData.STATE.type, {item: store.getState().reducerSplashGetAllData.STATE.item})
                                                    //    NavigationService.navigateParams('ProfileStack')
                                                } catch (e) {
                                                    console.log(e)
                                                    //  NavigationService.resetTo("Drawer")
                                                }
                                            }

                                        } else {
                                            dispatch(serviceActionSetUser(response.data.result))
                                            dispatch(serviceActionSetToken(response.data.result.token))
                                            NavigationService.Pop()
                                     /*       store.dispatch(serviceActionSetState({type: "ProfileScreen", item: null}))
                                            //     NavigationService.navigatereset('LoginEnterPhoneScreen')
                                            //this.props.navigation.goBack(null)
                                            AsyngStorageClass.removeToken();
                                            NavigationService.PopToPop()
                                            NavigationService.navigateParams('LoginEnterPhoneScreen')*/
                                        }

                                    }
                                },
                            ],
                            {cancelable: false}
                        )
                    } else {
                        dispatch(serviceActionRefresh())
                        alert(response.data.error.message)
                    }
                    break;


                default:
            }
        }).catch((e) => {
        dispatch(serviceActionError(e))
    })
}


export const callWebservice = (getState, url, params, type, typeConnection) => {

    return dispatch => {


        // NetInfo.isConnected.fetch().then(isConnected => {
        //     if (isConnected) {
        //         getDataDisatch(dispatch, getState, url, params, type, typeConnection);
        //     }
        //     else {
        //         dispatch(serviceActionError("No Internet Connection"));
        //
        //     }
        // });

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection"));
        //
        //         }
        //     }
        // )

                if (store.getState().reducerSplashGetAllData.Connection) {
                    getDataDisatch(dispatch, getState, url, params, type, typeConnection);
                } else {
                    dispatch(serviceActionError("No Internet Connection"));

                }


    }
}


export const serviceActionPending = () => ({
    type: typeExport.ChangPssScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    results: null

})

export const serviceActionError = (error) => ({
    type: typeExport.ChangPssScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    isLoading: false,
    error: error
})

export const serviceActionSuccess = (data) => ({
    type: typeExport.ChangPssScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    isLoading: false,
    results: data,


})

export const serviceActionRefresh = () => ({
    type: typeExport.ChangPssScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    isLoading: false,
    results: null
})
export default connect(mapStateToProps, mapDispatchToProps)(ChangPssScreen);
